import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import {
  selectCredentialId,
  selectCredentialPassword,
  selectCredentialUsername
} from 'store/Credentials/selectors';
import { Wrapper, ButtonWrapper, Key } from './styled';
import {
  Title,
  CancelButton,
  CreateButton,
  NextIcon
} from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal/components/Header/styled';
import {
  saveCredential,
  setCreateCredentialError,
  showCreateEditModal
} from 'store/Credentials/actions';

const Header = ({ isVulnDetail }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const id = useSelector(selectCredentialId);
  const username = useSelector(selectCredentialUsername);
  const password = useSelector(selectCredentialPassword);
  const text = id ? 'Save' : 'Create';
  const title = id
    ? intl.formatMessage({ id: 'credentials.modalCreateEdit.editTitle' })
    : intl.formatMessage({ id: 'credentials.modalCreateEdit.createTitle' });
  const enabled = username && password;

  const closeModal = () => dispatch(showCreateEditModal(false));

  const handleCreateCredential = () => {
    dispatch(saveCredential(isVulnDetail));
    closeModal();
  };

  const showErrorModal = () => dispatch(setCreateCredentialError(true));
  const handleSave = enabled ? handleCreateCredential : showErrorModal;

  useModalShortcuts({
    id: 'credential-create-edit',
    onSave: handleSave,
    onCancel: closeModal,
    saveLabel: text,
    enterToSave: true
  });

  return (
    <Wrapper>
      <Key />
      <Title children={ title } />
      <ButtonWrapper>
        <CancelButton onClick={ closeModal } children="Cancel" />
        <CreateButton
          onClick={ handleSave }
        >
          <>{text}</>
          <NextIcon />
        </CreateButton>
      </ButtonWrapper>
    </Wrapper>
  );
};

export default Header;
